import {z} from 'zod'

import {tzDateFromIso} from 'src/api/zod-helpers'

const rentalReportRowRawSchema = z.object({
    quantity: z.number(),
    rental_asset_id: z.string().nullable(),
    asset_display_name: z.string(),
    rental_asset_type_id: z.string(),
    rental_asset_type_name: z.string(),
    customer_id: z.string(),
    customer_name: z.string(),
    project_id: z.string(),
    project_name: z.string(),
    location_label: z.string(),
    status: z.enum(['deployed', 'picked_up', 'dispatched']),
    days_out: z.number(),
    deployed_at: z.string(),
})

export const rentalReportRawSchema = z.object({
    start_date: z.string(),
    end_date: z.string(),
    rows: z.array(rentalReportRowRawSchema),
})

export const rentalReportSchema = rentalReportRawSchema.transform((raw) => ({
    startDate: raw.start_date,
    endDate: raw.end_date,
    rows: raw.rows.map((row) => ({
        quantity: row.quantity,
        rentalAssetId: row.rental_asset_id,
        assetDisplayName: row.asset_display_name,
        rentalAssetTypeId: row.rental_asset_type_id,
        rentalAssetTypeName: row.rental_asset_type_name,
        customerId: row.customer_id,
        customerName: row.customer_name,
        projectId: row.project_id,
        projectName: row.project_name,
        locationLabel: row.location_label,
        status: row.status,
        daysOut: row.days_out,
        deployedAt: tzDateFromIso.parse(row.deployed_at),
    })),
}))

export type RentalReport = z.infer<typeof rentalReportSchema>
export type RentalReportRow = RentalReport['rows'][number]

export function isStockRentalReportRow(row: RentalReportRow) {
    return row.rentalAssetId == null
}
